<template>
  <!-- 顶部导航 -->
  <div class="header" v-on:mouseleave="handleave(1)">
    <div class="container-top">
      <div class="nav-topbar">
        <div class="logo">
          <img
            src="../../public/imgs/header_logo.png"
            width="100%"
            height="auto"
          />
        </div>
        <div class="logo-text">
          <p>专注于电能质量与无功补偿技术</p>
          <p>致力于不断创造先进技术和产品</p>
        </div>

        <div class="container">
      
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1">处理中心</el-menu-item>
          <el-submenu index="2">
            <template slot="title">我的工作台</template>
            <el-menu-item index="2-1">选项1</el-menu-item>
            <el-menu-item index="2-2">选项2</el-menu-item>
            <el-menu-item index="2-3">选项3</el-menu-item>
            <el-submenu index="2-4">
              <template slot="title">选项4</template>
              <el-menu-item index="2-4-1">选项1</el-menu-item>
              <el-menu-item index="2-4-2">选项2</el-menu-item>
              <el-menu-item index="2-4-3">选项3</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-menu-item index="3" disabled>消息中心</el-menu-item>
          <el-menu-item index="4"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item>
        </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "nav-header",
  props: ["navs", "navsitems"],
  data() {
    return {
      a: 1,
      b: "",
      activeIndex:1,
      activenava: "",
      nava: "",
      activea: 1,
      showsNav: false,
      phoneList: [],
    };
  },
  watch: {
    navs: {
      handler(newVal) {
        this.b = newVal;
        this.activea = newVal;
        this.a = newVal;
        this.showsNav = true;
      },
      // 立即处理 进入页面就触发
      immediate: true,
      // 深度监听 属性的变化
      deep: true,
    },
    navsitems: {
      handler(newVal) {
        this.activenava = newVal;
        this.nava = newVal;
      },
      // 立即处理 进入页面就触发
      immediate: true,
      // 深度监听 属性的变化
      deep: true,
    },
  },
  methods: {
  handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handlenav(val) {
      let self = this;
      self.nava = val;
    },
    handleHover(val) {
      let self = this;
      self.a = val;
      self.b = val;
      self.showsNav = true;
    },
    handleave(val) {
      let self = this;
      if (self.activea == 1) {
        self.b = "";
        self.nava = "";
        self.showsNav = false;
      } else {
        self.b = self.activea;
        self.nava = self.activenava;
      }
      self.a = self.activea;
    },
    goPages(val, a, b) {
      let self = this;
      self.activea = a;
      self.a = a;
      //self.nava = "";
      self.b = a;
      self.nava = b;
      this.$router.push(val);
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "./../assets/scss/base.scss";
// @import "./../assets/scss/config.scss";
.header {
  z-index: 33;
  position: fixed;
  width: 100%;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  /**
  .v-enter {
    opacity: 0;
    transform: translateY(150px);
  }
  .v-enter-active {
    transition: all 0.5s ease;
  }**/
  .container-nav {
    width: 100%;
    overflow: hidden;
    background: rgba(250, 250, 250, 0.5);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    .nav-centers {
      width: 1600px;
      overflow: hidden;
      margin: 0 auto;
      .navactive {
        background: #fff;
        span {
          height: 30px;
          line-height: 30px;
          margin: 14px auto;
          width: 100%;
          border-bottom: 1px solid #1d8d3b;
          display: inline-block;
        }
      }
      .nav-items {
        display: block;
        float: left;
        overflow: hidden;
        padding-left: 20px;
        padding-right: 20px;
        text-align: center;
        line-height: 60px;
        position: relative;
        cursor: pointer;
      }
    }
  }

  .container-top {
    width: 100%;
    margin: 0 auto;
    background: #fff;
  }
  .nav-topbar {
    width: 100%;
    overflow: hidden;
    margin: 0 auto;

    max-width: 1600px;
    padding-top: 28px;
    padding-bottom: 10px;
    .logo {
      float: left;
      width: 238px;
      overflow: hidden;
      border-right: 1px solid #dfdfdf;
    }
    .logo-text {
      float: left;
      width: 278px;
      overflow: hidden;
      p {
        font-size: 16px;
        text-align: center;
        line-height: 16px;
        width: 100%;
        overflow: hidden;
        color: #1d8d3b;
        font-weight: 700;
      }
    }

    .container {
      @include flex();
      float: right;
      width: 52%;
      overflow: hidden;
      line-height: 32px;
      .active {
        // font-weight: bold;
        color: #1d8d3b !important;
      }
      .activea {
        font-weight: bold;
        color: #1d8d3b !important;
      }
      .active-line {
        display: inline-block;
        line-height: 32px;
        color: #1d8d3b;
        border-bottom: 3px solid #d51419;
      }
      .item-topbar {
        font-size: 16px;
        display: inline-block;
        color: #333;
        cursor: pointer;
      }
    }
  }
}
</style>